export default {
  title: {
    en: 'Need a break? Pause instead',
  },
  text: {
    en: `
    Instead of cancelling your subscription, pausing your account is easily undone and allows you 
    to return with all of your information saved, including your queue and recommendations. 
    Otherwise, you may be placed on a waitlist if you choose to re-subscribe after cancelling your subscription 
    and any free months on your account will be lost.
  `,
  },
  buttonBack: {
    en: 'Go back',
  },
  buttonPause: {
    en: 'Pause my account',
  },
}
